import { createFileRoute } from "@tanstack/react-router";
import TusDatos from "../pages/TusDatos";

export const Route = createFileRoute("/tus-datos")({
  component: TusDatos,
});
